import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { PropType, computed, ref } from 'vue';
import { Product, showProducts, formatStatus } from 'ah-api-gateways';
import { formatDate } from '../../../../../../packages/ah-common-lib/src/helpers/time';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsDetailsModal',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  setup(__props, { expose }) {

const props = __props;

const modal = ref<BModal | null>(null);



const title = computed(() => `History of pair ${props.product.currencyPair}`);

expose({
  modal,
});

return { __sfc: true,modal, props, title, BModal, showProducts, formatStatus, formatDate, MaterialIcon }
}

})